import { Component, OnInit, Input } from '@angular/core';
import { NormalizedPlanBaseModel, NormalizedSubscriptionPlan } from '@frontend/unhideschool/modules/membership/models/membership-normalized-plan.model';

@Component({
  selector: 'unh-price-box-team',
  templateUrl: './price-box-team.component.html',
  styleUrls: ['./price-box-team.component.scss']
})
export class PriceBoxTeamComponent implements OnInit {
  @Input() plan: NormalizedSubscriptionPlan;

  constructor() { }

  ngOnInit(): void {
  }

}
